export const TitleBar = () => {
  return (
    <span className="title-bar" />
  )
}